import React from 'react';
import Seo from '../components/common/Seo';
import about_hero from '../assets/images/about_hero.webp';
import AboutHero from '../components/about/AboutHero';
import CompanyHistory from '../components/about/CompanyHistory';
import MissionVision from '../components/about/MissionVision';
import StatsBanner from '../components/about/StatsBanner';
import MeetOurTeam from '../components/about/MeetOurTeam';
import OurSuccess from '../components/about/OurSuccess';

const About = () => {
  return (
    <div className="w-full">
      <Seo
        title="About Agastya Agro | Mission, Team & Growth Story"
        description="Discover Agastya Agro's journey, values, and leadership team driving practical, science-backed solutions for farmers across India."
      />
      {/* Hero Section with Component-based Design */}
      <AboutHero 
        heroImage={about_hero}
        title="About Agastya Agro Limited"
        subtitle="Agastya Agro Limited"
      />
      <CompanyHistory />
      <MissionVision />
      <OurSuccess />
      <StatsBanner />
      <MeetOurTeam />
    </div>
  );
};

export default About;
